import { Card } from "@/components/ui/Primitives";
import { Phone, Mail } from "lucide-react";

// Compact support strip shown at the bottom of every role's dashboard.
export default function SupportStrip({ testid }) {
  return (
    <Card className="mt-8 p-5 flex flex-col sm:flex-row items-center justify-between gap-4" data-testid={testid}>
      <div className="text-sm text-slate-600 text-center sm:text-left">
        <span className="font-display font-bold text-slate-900">Need a hand?</span> Our team is here Mon–Fri, 9am–6pm MT.
      </div>
      <div className="flex items-center gap-2 flex-wrap justify-center">
        <a href="tel:780-405-2498" data-testid={`${testid}-phone`}
          className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg bg-green-50 border border-green-100 text-green-900 text-sm font-semibold hover:bg-green-100 transition-colors">
          <Phone className="w-4 h-4"/> 780-405-2498
        </a>
        <a href="mailto:contact@centralrentals.ca" data-testid={`${testid}-email`}
          className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg bg-slate-50 border border-slate-200 text-slate-800 text-sm font-semibold hover:bg-slate-100 transition-colors">
          <Mail className="w-4 h-4"/> contact@centralrentals.ca
        </a>
      </div>
    </Card>
  );
}
